import * as React from 'react';
export const savingsBankSvg = React.forwardRef(function savingsBankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F6F8FA',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.872 18.892c-.187 1.024.337 1.353 1.248 1.353.645 0 1.368-.245 1.514-.89.174-.768-.967-.914-2.074-1.27-1.094-.352-2.198-.913-1.837-2.51.431-1.902 2.407-2.647 3.95-2.647 1.636 0 3.093.841 2.659 2.806H11.19c.214-.792-.431-1.05-1.087-1.05-.461 0-1.075.17-1.204.745-.153.67 1.005.792 2.122 1.147 1.107.352 2.17.937 1.815 2.51-.5 2.204-2.433 2.914-4.24 2.914-1.807 0-3.36-.877-2.867-3.11h2.143v.002Zm14.818-5.78h2.14l-1.973 8.706h-2.142l1.974-8.706Zm-7.806 0h3.845c1.423-.023 2.889.365 2.477 2.182-.177.78-.758 1.416-1.48 1.756.815.269 1.173 1.075.95 2.061-.47 2.074-2.053 2.707-3.815 2.707h-3.949l1.973-8.706Zm1.365 3.426h1.657c.369 0 .923-.207 1.063-.83.145-.633-.235-.841-.684-.841h-1.658l-.378 1.671Zm-.785 3.463h1.716c.68 0 1.209-.257 1.372-.974.175-.768-.274-1.024-.92-1.024h-1.716l-.453 2 .001-.002Z',
      fill: '#005EA1',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M27.822 9.614c-1.184-3.143-7.957-3.503-15.127-.802C7.58 10.739 3.647 13.7 2.24 16.384c1.946-2.033 5.088-4.029 8.88-5.459 7.17-2.7 13.944-2.341 15.128.804.34.9.182 1.934-.384 3.014 1.733-1.81 2.516-3.647 1.958-5.128',
      fill: '#EE303C',
    }),
  );
});
savingsBankSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var savingsBank = {
  category: 'brand',
  colorable: false,
  name: 'savingsBank',
  svg: savingsBankSvg,
};
